module.exports = __webpack_public_path__ + "media/src/images/page02_sub_001_zu04-abb464715156d4e2349b39e41d35dbb2.png";